import { useState }           from 'react';

import useOnClickOutside      from '../../hooks/useOnClickOutside'

function useMobileMenu(menuRef) {
    const [ isOpen, setOpen ] = useState(false);

    useOnClickOutside(menuRef, handleClose)

    function handleOpen() {
        setOpen(true)
    }

    function handleClose() {
        setOpen(false)
    }

    return {
        handleOpen,
        handleClose,
        isOpen
    };
}

export default useMobileMenu;
